module.exports = __webpack_public_path__ + "img/cdc2c0c.png";